import { getBaseUrl } from '../utils/Utils';
import { AccessToken, ProjectsInfoRequest, ProjectsInfoResponse } from '../types'
import { BillingsResponse, BuyPlanRequest } from '../types/common.type';
import BaseService from './BaseService';
import {
  SERVICE_TRACKING_ADD_KEYWORDS, SERVICE_TRACKING_GET_PROJECT_SOV, SERVICE_TRACKING_GET_SERPS,
  SERVICE_USERS_CREATE_CHECKOUT,
  SERVICE_USERS_REDIRECT_STRIPE,
  SERVICE_USERS_RETRIEVE_CHECKOUT
} from './Endpoint'
import * as SERVICES from './Endpoint'

class TrackingService extends BaseService {
  async getTrackingProjects(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_GET_PROJECTS}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

  async addTrackingProject(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_ADD_PROJECT}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

  async delTrackingProject(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_DEL_PROJECT}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

  async getTrackingKeywords(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_GET_KEYWORDS}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

  async addTrackingKeywords(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_ADD_KEYWORDS}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

  async delTrackingKeywords(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_DEL_KEYWORDS}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

  async getSov(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_GET_PROJECT_SOV}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

  async getRankRanges(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_GET_RANK_RANGES}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

  async getSerps(params: ProjectsInfoRequest): Promise<ProjectsInfoResponse> {
    const { id, accessToken, ...rest } = params;
    const baseUrl =  `${getBaseUrl()}${SERVICES.SERVICE_TRACKING_GET_SERPS}`;
    const data = { id, ...rest };
    const response = await this.post(baseUrl, data, accessToken);
    return response.data ?? { items: [] };
  }

}

export const trackingService = new TrackingService();
